import { render, staticRenderFns } from "./StepButtons.vue?vue&type=template&id=21129081&"
import script from "./StepButtons.vue?vue&type=script&lang=js&"
export * from "./StepButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports